<script>
import feather from 'feather-icons';
import FooterCopyright from './FooterCopyright.vue';
import { socialLinks } from '../../data/socialLinks';

export default {
	components: { FooterCopyright },
	data() {
		return { socials: socialLinks };
	},
	mounted() { feather.replace(); },
	updated() { feather.replace(); },
};
</script>

<template>
	<footer class="relative mt-20 border-t border-gray-200 dark:border-white/[0.06]">
		<div class="container mx-auto pt-6">
			<div class="surface-card p-6 sm:p-8 flex flex-col md:flex-row md:items-center md:justify-between gap-6" data-aos="fade-up" data-aos-delay="50">
				<div>
					<p class="eyebrow mb-2">Available for AI automation & SaaS builds</p>
					<h2 class="font-general-bold text-2xl sm:text-3xl text-gray-900 dark:text-white">
						Ready to replace manual work with a system?
					</h2>
				</div>
				<router-link
					to="/contact"
					class="btn-gradient inline-flex items-center justify-center px-6 py-3 rounded-lg text-white font-general-medium text-sm shadow-lg"
				>
					Start a Project
				</router-link>
			</div>
		</div>
		<div class="container mx-auto py-16">
			<!-- Social links -->
			<div class="flex flex-col items-center gap-8" data-aos="fade-up" data-aos-delay="100">
				<p class="font-general-semibold text-sm uppercase tracking-widest text-gray-400 dark:text-slate-500">
					Find me on
				</p>

				<ul class="flex gap-3">
					<a
						v-for="(social, index) in socials"
						:key="social.id"
						:href="social.url"
						target="_blank"
						rel="noopener noreferrer"
						class="w-11 h-11 flex items-center justify-center rounded-lg border transition-all duration-300 group"
						:class="'border-gray-200 dark:border-white/10 bg-white dark:bg-white/5 text-gray-500 dark:text-slate-400 hover:border-amber-400 dark:hover:border-amber-500/60 hover:text-amber-600 dark:hover:text-amber-400 hover:bg-amber-50 dark:hover:bg-amber-500/10'"
						:data-aos="'zoom-in'"
						:data-aos-delay="200 + index * 80"
					>
						<i :data-feather="social.icon" class="w-4 h-4" />
					</a>
				</ul>

				<!-- Divider -->
				<div class="w-16 h-px bg-gradient-to-r from-transparent via-amber-500/40 to-transparent" />

				<!-- Copyright -->
				<FooterCopyright />
			</div>
		</div>
	</footer>
</template>
